import { Routes } from '@angular/router';

export const planningRoutes: Routes = [
  {
    path: 'planning/reference-data',
    loadComponent: () =>
      import('./reference-data/reference-data.component').then(
        (c) => c.ReferenceDataComponent
      ),
  },
  {
    path: 'planning/parameters',
    loadComponent: () =>
      import('./planning-parameters/planning-parameters.component').then(
        (c) => c.PlanningParametersComponent
      ),
  },
  {
    path: 'planning/parameters/:demandCycleUuid',
    loadComponent: () =>
      import('./planning-parameters/planning-parameters.component').then(
        (c) => c.PlanningParametersComponent
      ),
  },
  {
    path: 'planning/parameters/details/:uuid',
    loadComponent: () =>
      import(
        './planning-parameters/planning-parameter-details/planning-parameter-details.component'
      ).then((c) => c.PlanningParameterDetailsComponent),
  },
];
